// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BackgroundProgressController from "./background_progress_controller"
application.register("background-progress", BackgroundProgressController)

import CheckboxSelectAllController from "./checkbox_select_all_controller"
application.register("checkbox-select-all", CheckboxSelectAllController)

import CheckboxSubmitController from "./checkbox_submit_controller"
application.register("checkbox-submit", CheckboxSubmitController)

import Chart from 'stimulus-chartjs'
application.register('chart', Chart)

import CopyButtonController from "./copy_button_controller"
application.register("copy-button", CopyButtonController)

import DestructiveConfirmationController from "./destructive_confirmation_controller"
application.register("destructive-confirmation", DestructiveConfirmationController)

import ExpirationCleanupController from "./expiration_cleanup_controller"
application.register("expiration-cleanup", ExpirationCleanupController)

import ExpirationCleanupConfirmationController from "./expiration_cleanup_confirmation_controller"
application.register("expiration-cleanup-confirmation", ExpirationCleanupConfirmationController)

import ExportSizeCheckController from "./export_size_check_controller"
application.register("export-size-check", ExportSizeCheckController)

import FeaturebaseController from "./featurebase_controller"
application.register("featurebase", FeaturebaseController)

import MoverController from "./mover_controller"
application.register("mover", MoverController)

import MoveConfirmationController from "./move_confirmation_controller"
application.register("move-confirmation", MoveConfirmationController)

import MoveFolderPickerController from "./move_folder_picker_controller"
application.register("move-folder-picker", MoveFolderPickerController)

import PhotosDragController from "./photos_drag_controller"
application.register("photos-drag", PhotosDragController)

import PhotosUploadController from "./photos_upload_controller"
application.register("photos-upload", PhotosUploadController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import RackStorageFormToggleController from "./rack_storage_form_toggle_controller"
application.register("rack-storage-form-toggle", RackStorageFormToggleController)

import HudiniController from "./hudini_controller"
application.register("hudini", HudiniController)

import HudiniDockController from "./hudini_dock_controller"
application.register("hudini-dock", HudiniDockController)

import HudiniSkillsController from "./hudini_skills_controller"
application.register("hudini-skills", HudiniSkillsController)

import HudiniMentionsController from "./hudini_mentions_controller"
application.register("hudini-mentions", HudiniMentionsController)

import HudiniChatListController from "./hudini_chat_list_controller"
application.register("hudini-chat-list", HudiniChatListController)

import HudiniModelController from "./hudini_model_controller"
application.register("hudini-model", HudiniModelController)

import HudiniContextController from "./hudini_context_controller"
application.register("hudini-context", HudiniContextController)

import HudiniQuestionsController from "./hudini_questions_controller"
application.register("hudini-questions", HudiniQuestionsController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import InlineCreatorController from "./inline_creator_controller"
application.register("inline-creator", InlineCreatorController)

import AutoProvisioningController from "./auto_provisioning_controller"
application.register("auto-provisioning", AutoProvisioningController)

import AdvancedSearchController from "./advanced_search_controller"
application.register("advanced-search", AdvancedSearchController)

import CopyInputController from "./copy_input_controller"
application.register("copy-input", CopyInputController)

import ConfirmInputController from "./confirm_input_controller"
application.register("confirm-input", ConfirmInputController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import KeyboardShortcutsController from "./keyboard_shortcuts_controller"
application.register("keyboard-shortcuts", KeyboardShortcutsController)

import CommentsController from "./comments_controller"
application.register("comments", CommentsController)

import BridgeEncryptionController from "./bridge_encryption_controller"
application.register("bridge-encryption", BridgeEncryptionController)

import ArchivedToggleController from "./archived_toggle_controller"
application.register("archived-toggle", ArchivedToggleController)

import FilterBarController from "./filter_bar_controller"
application.register("filter-bar", FilterBarController)

import FramePollController from "./frame_poll_controller"
application.register("frame-poll", FramePollController)

import RelationsSidepanelController from "./relations_sidepanel_controller"
application.register("relations-sidepanel", RelationsSidepanelController)

import AiEndpointController from "./ai_endpoint_controller"
application.register("ai-endpoint", AiEndpointController)

import EmbeddingsConfigController from "./embeddings_config_controller"
application.register("embeddings-config", EmbeddingsConfigController)

import RequiredFieldsController from "./required_fields_controller"
application.register("required-fields", RequiredFieldsController)

import TableSearchController from "./table_search_controller"
application.register("table-search", TableSearchController)

import Dropdown from './dropdown_controller'
application.register('dropdown', Dropdown)

import SimpleSelect from './simple_select_controller'
application.register('simple-select', SimpleSelect)

import TextFieldFilterController from './text_field_filter_controller'
application.register('text-field-filter', TextFieldFilterController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)

import ToolbarToggleController from "./toolbar_toggle_controller"
application.register("toolbar-toggle", ToolbarToggleController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import RequiredInputController from "./required_input_controller"
application.register("required-input", RequiredInputController)

import IntegrationSettingsToggleController from "./integration_settings_toggle_controller"
application.register("integration_settings_toggle", IntegrationSettingsToggleController)

import RealtimeRefreshController from "./realtime_refresh_controller"
application.register("realtime-refresh", RealtimeRefreshController)

import TwoFaFormController from "./two_fa_form_controller"
application.register("two-fa-form", TwoFaFormController)

import AssetLayoutIconController from "./asset_layout_icon_controller"
application.register("asset-layout-icon", AssetLayoutIconController)

import DateController from "./date_controller"
application.register("date", DateController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)

import NameEditController from "./name_edit_controller"
application.register("name-edit", NameEditController)

import ConnectionTestController from "./connection_test_controller"
application.register("connection-test", ConnectionTestController)

import SwaggerController from "./swagger_controller"
application.register("swagger", SwaggerController)

import DashboardImageController from "./dashboard_image_controller"
application.register("dashboard-image", DashboardImageController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)

import StarFilterController from "./star_filter_controller"
application.register("star-filter", StarFilterController)

import NameListController from "./name_list_controller"
application.register("name-list", NameListController)

import KbContentController from "./kb_content_controller"
application.register("kb-content", KbContentController)

import KbSyncCompaniesController from "./kb_sync_companies_controller"
application.register("kb-sync-companies", KbSyncCompaniesController)

import TreeViewController from "./tree_view_controller"
application.register("tree-view", TreeViewController)

import HeaderVisibilityController from "./header_visibility_controller"
application.register("header-visibility", HeaderVisibilityController)

import HeaderSearchController from "./header_search_controller"
application.register("header-search", HeaderSearchController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import SecureNoteController from "./secure_note_controller"
application.register("secure-note", SecureNoteController)

import SecureNoteRevealController from "./secure_note_reveal_controller"
application.register("secure-note-reveal", SecureNoteRevealController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import RadioToggleController from "./radio_toggle_controller"
application.register("radio-toggle", RadioToggleController)

import MapboxController from "./mapbox_controller"
application.register("mapbox", MapboxController)

import SubnetRangeController from "./subnet_range_controller"
application.register("subnet-range", SubnetRangeController)

import PasswordViewerController from "./password_viewer_controller"
application.register("password-viewer", PasswordViewerController)

import PasswordsController from "./passwords_controller"
application.register("passwords", PasswordsController)

import CheckAllController from "./check_all_controller"
application.register("check-all", CheckAllController)

import IndeterminateCheckboxController from "./indeterminate_checkbox_controller"
application.register("indeterminate-checkbox", IndeterminateCheckboxController)

import CountryRegionSelectController from "./country_region_select_controller"
application.register("country-region-select", CountryRegionSelectController)

import SessionTimeoutController from "./session_timeout_controller"
application.register("session-timeout", SessionTimeoutController)

import FavoriteSorterController from "./favorite_sorter_controller"
application.register("favorite-sorter", FavoriteSorterController)

import ActivityLogController from "./activity_log_controller"
application.register("activity-log", ActivityLogController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import GoogleAuthController from "./google_auth_controller"
application.register("google-auth", GoogleAuthController)

import NetworkMapController from "./network_map_controller"
application.register("network-map", NetworkMapController)

import RadarFieldEditorController from "./radar_field_editor_controller"
application.register("radar-field-editor", RadarFieldEditorController)

import RadarDeviceSelectorController from "./radar_device_selector_controller"
application.register("radar-device-selector", RadarDeviceSelectorController)

import RadarFilterController from "./radar_filter_controller"
application.register("radar-filter", RadarFilterController)

import RadarActivationController from "./radar_activation_controller"
application.register("radar-activation", RadarActivationController)

import RadarSyncController from "./radar_sync_controller"
application.register("radar-sync", RadarSyncController)

//
//
//
//
//
//
// VUE COMPONENTS (Need to convert to Stimulus later. slowly working our way through them). Also there is a chance a few of them are not vue.js
//
//
//
//
//
//

import OtpGeneratorController from "./otp_generator_controller"
application.register("otp-generator", OtpGeneratorController)

import BridgeConnectorController from "./bridge_connector_controller"
application.register("bridge-connector", BridgeConnectorController)

import BridgeFormController from "./bridge_form_controller"
application.register("bridge-form", BridgeFormController)

import PasswordEditorController from "./password_editor_controller"
application.register("password-editor", PasswordEditorController)

import OtpInputController from "./otp_input_controller"
application.register("otp-input", OtpInputController)

import LayoutSorterController from "./layout_sorter_controller"
application.register("layout-sorter", LayoutSorterController)

import LayoutNameSelectorController from "./layout_name_selector_controller"
application.register("layout-name-selector", LayoutNameSelectorController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import WidgetTogglerController from "./widget_toggler_controller"
application.register("widget-toggler", WidgetTogglerController)

import ProcedureTaskController from "./procedure_task_controller"
application.register("procedure-task", ProcedureTaskController)

import ProcedureFormController from "./procedure_form_controller"
application.register("procedure-form", ProcedureFormController)

import ProcedureTaskSorterController from "./procedure_task_sorter_controller"
application.register("procedure-task-sorter", ProcedureTaskSorterController)

import ProcedureRunCopyController from "./procedure_run_copy_controller"
application.register("procedure-run-copy", ProcedureRunCopyController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import RelaterController from "./relater_controller"
application.register("relater", RelaterController)

import DashboardItemSorterController from "./dashboard_item_sorter_controller"
application.register("dashboard-item-sorter", DashboardItemSorterController)

import ListEditorController from "./list_editor_controller"
application.register("list-editor", ListEditorController)

import MultiTextInputController from "./multi_text_input_controller"
application.register("multi-text-input", MultiTextInputController)

import FileManagerController from "./file_manager_controller"
application.register("file-manager", FileManagerController)

import AssetLayoutSorterController from "./asset_layout_sorter_controller"
application.register("asset-layout-sorter", AssetLayoutSorterController)

import ArticleWriterController from "./article_writer_controller"
application.register("article-writer", ArticleWriterController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import ImporterController from "./importer_controller"
application.register("importer", ImporterController)

import BulkUserImporterController from "./bulk_user_importer_controller"
application.register("bulk-user-importer", BulkUserImporterController)

import RolerController from "./roler_controller"
application.register("roler", RolerController)

import BulkUserInviterController from "./bulk_user_inviter_controller"
application.register("bulk-user-inviter", BulkUserInviterController)

import PdfUploaderController from "./pdf_uploader_controller"
application.register("pdf-uploader", PdfUploaderController)

import TemplateChooserController from "./template_chooser_controller"
application.register("template-chooser", TemplateChooserController)


import ListPickerController from "./list_picker_controller"
application.register("list-picker", ListPickerController)

import RecordPickerController from "./record_picker_controller"
application.register("record-picker", RecordPickerController)

import TaggerController from "./tagger_controller"
application.register("tagger", TaggerController)

import CustomFastFacterController from "./custom_fast_facter_controller"
application.register("custom-fast-facter", CustomFastFacterController)

import RecolorRecordsController from "./recolor_records_controller"
application.register("recolor-records", RecolorRecordsController)

import WorkflowCanvasController from "./workflow_canvas_controller"
application.register("workflow-canvas", WorkflowCanvasController)

import WorkflowSidebarController from "./workflow_sidebar_controller"
application.register("workflow-sidebar", WorkflowSidebarController)

import WorkflowCheckboxGroupController from "./workflow_checkbox_group_controller"
application.register("workflow-checkbox-group", WorkflowCheckboxGroupController)

import PhotosSearchController from "./photos_search_controller"
application.register("photos-search", PhotosSearchController)

import PhotosViewController from "./photos_view_controller"
application.register("photos-view", PhotosViewController)

import AlertFormController from "./alert_form_controller"
application.register("alert-form", AlertFormController)

import FormAutosaveController from "./form_autosave_controller"
application.register("form-autosave", FormAutosaveController)

import FormAutosaveStatusController from "./form_autosave_status_controller"
application.register("form-autosave-status", FormAutosaveStatusController)

import FormBuilderContentController from "./form_builder_content_controller.js"
application.register("form-builder-content", FormBuilderContentController)

import TiptapController from "./tiptap_controller"
application.register("tiptap", TiptapController)

import AssetLayoutFolderToggleController from "./asset_layout_folder_toggle_controller"
application.register("asset-layout-folder-toggle", AssetLayoutFolderToggleController)

import BulkSelectorController from "./bulk_selector_controller"
application.register("bulk-selector", BulkSelectorController)

import ColumnResizeController from "./column_resize_controller"
application.register("column-resize", ColumnResizeController)

import ChangeCompanyMatchesController from "./change_company_matches_controller"
application.register("change-company-matches", ChangeCompanyMatchesController)

import FloatingActionMenuController from "./floating_action_menu_controller"
application.register("floating-action-menu", FloatingActionMenuController)

import EmailConfigController from "./email_config_controller"
application.register("email-config", EmailConfigController)

import UnsavedChangesController from "./unsaved_changes_controller"
application.register("unsaved-changes", UnsavedChangesController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import CompanySwitcherController from "./company_switcher_controller"
application.register("company-switcher", CompanySwitcherController)

import SecretFieldController from "./secret_field_controller"
application.register("secret-field", SecretFieldController)

import LabelTypeFormController from "./label_type_form_controller"
application.register("label-type-form", LabelTypeFormController)

import UpdateNotificationController from "./update_notification_controller"
application.register("update-notification", UpdateNotificationController)

import LayoutSelectorController from "./layout_selector_controller"
application.register("layout-selector", LayoutSelectorController)

import SetupPersonalizeController from "./setup_personalize_controller"
application.register("setup-personalize", SetupPersonalizeController)

import FilterChipController from "./filter_chip_controller"
application.register("filter-chip", FilterChipController)

import FilterOptionListController from "./filter_option_list_controller"
application.register("filter-option-list", FilterOptionListController)

import LabelsToolbarController from "./labels_toolbar_controller"
application.register("labels-toolbar", LabelsToolbarController)

import RadarMultiLocationMigrationController from "./radar_multi_location_migration_controller"
application.register("radar-multi-location-migration", RadarMultiLocationMigrationController)

import LabelsPickerController from "./labels_picker_controller"
application.register("labels-picker", LabelsPickerController)

import InfoRequestWizardController from "./info_request_wizard_controller"
application.register("info-request-wizard", InfoRequestWizardController)
import QrLabelFieldsController from "./qr_label_fields_controller"
application.register("qr-label-fields", QrLabelFieldsController)

import ScrollPreserveController from "./scroll_preserve_controller"
application.register("scroll-preserve", ScrollPreserveController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)
